import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import useField from '../hooks/use-field'

function Checkbox (props) {
  const {
    id,
    name,
    value,
    onChange,
    wrap
  } = useField(props)

  return wrap(() => (
    <>
      <input type='hidden' name={name} value={(value === true || value === 1) ? 1 : 0} />
      <input
        id={id}
        type='checkbox'
        onChange={() => onChange(!value)}
        checked={value}
        disabled={props.disabled}
        readOnly={props.readOnly}
        value={(value === true || value === 1) ? 1 : 0}
      />
    </>
  ))
}

Checkbox.defaultProps = {
  defaultValue: null,
  readOnly: false,
  disabled: false,
  required: false,
  className: ''
}

Checkbox.propTypes = {
  name: PropTypes.string,
  defaultValue: PropTypes.any,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string
}

export default observer(Checkbox)
